import boddVariables from '../variables.module.scss';

export enum DialGroup {
    NeedsAttention,
    Poor,
    Average,
    Good,
    Excellent,
}

const getColourForDialGroup = (dialGroup: DialGroup) => {
    switch (dialGroup) {
        case DialGroup.NeedsAttention: return boddVariables.needsAttention;
        case DialGroup.Poor: return boddVariables.poor;
        case DialGroup.Average: return boddVariables.average;
        case DialGroup.Good: return boddVariables.good;
        case DialGroup.Excellent: return boddVariables.excellent;
        default: return boddVariables.white;
    }
};

export const getLabelForDialGroup = (dialGroup: DialGroup) => {
    switch (dialGroup) {
        case DialGroup.NeedsAttention: return 'Needs Attention';
        case DialGroup.Poor: return 'Poor';
        case DialGroup.Average: return 'Average';
        case DialGroup.Good: return 'Good';
        case DialGroup.Excellent: return 'Excellent';
        default: return '';
    }
};

export default getColourForDialGroup;
